import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsEnabledOnGridWithSettingsBaseValueConverter {
    toView(array, settings) {
        let tempArray = new Array<Object>();
        let filteredArray = array.filter((item) => item['VisibleOnGrid'] != null && item['VisibleOnGrid'] == 2);

        for(let index in filteredArray) {
            let value = filteredArray[index];
            
            let itemIndex = settings.map(function (item) { return item.ColumnName; }).indexOf(value['ColumnName']);

            if(itemIndex >= 0) {
                tempArray[itemIndex] = value;
            }
        }

        return tempArray;
    }
}